module.exports = {
  renderer: [ 'type', require(87) ],
  styles: [ 'type', require(88) ]
};